"use strict";
var controller = function($scope) {
  var init = function() {
    $scope.username = window.username;
  };
  init();
};
module.exports = controller;
